import * as React from 'react';

import { css, keyframes } from '@emotion/react';

const scale = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }

  45% {
    transform: scale(0.1);
    opacity: 0.7;
  }

  80% {
    transform: scale(1);
    opacity: 1;
  }
`;

const loader = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;

  > div {
    display: block;
    width: 15px;
    height: 15px;
    margin: 2px;
    border-radius: 50%;
    background: #00cfc8; /* replace with your bright teal */
  }

  > div:nth-of-type(1) {
    animation: ${scale} 0.75s 0.12s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
  }

  > div:nth-of-type(2) {
    animation: ${scale} 0.75s 0.24s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
  }

  > div:nth-of-type(3) {
    animation: ${scale} 0.75s 0.36s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
  }
`;

export const BallLoader: React.FC = () => (
  <div css={loader}>
    <div />
    <div />
    <div />
  </div>
);
